export const formatDate = dateTime => {
  const date = new Date(Date.parse(dateTime));
  return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
}
